import React from 'react';
import { useTranslation } from 'react-i18next';
import './About.css';

function About() {
  const { t } = useTranslation();

  return (
    <div className="about-page">
      <div className="about-container">
        <div className="about-header">
          <div className="about-logo">
            <span className="logo-icon">✨</span>
            <span className="logo-text">dailyzodiac.ai</span>
          </div>
          <h1>{t('about.title')}</h1>
          <p className="about-tagline">{t('about.tagline')}</p>
        </div>

        <div className="about-content">
          <section className="about-section">
            <h2>{t('about.who.title')}</h2>
            <p>{t('about.who.text')}</p>
            <p>{t('about.who.text2')}</p>
          </section>

          <section className="about-section">
            <h2>{t('about.what.title')}</h2>
            <p>{t('about.what.text')}</p>
            <ul>
              <li>{t('about.what.item1')}</li>
              <li>{t('about.what.item2')}</li>
              <li>{t('about.what.item3')}</li>
              <li>{t('about.what.item4')}</li>
            </ul>
          </section>

          <section className="about-section">
            <h2>{t('about.how.title')}</h2>
            <p>{t('about.how.text')}</p>
            <p>{t('about.how.text2')}</p>
          </section>

          <section className="about-section">
            <h2>How to read our horoscopes</h2>
            <p>
              Our daily texts blend long-standing astrological symbolism with modern technology to
              offer gentle prompts for reflection about your day.
            </p>
            <p>
              We design each horoscope to feel personal and uplifting, but it should complement your
              own judgment, not replace professional advice on important life, medical or financial decisions.
            </p>
          </section>

          <section className="about-section">
            <h2>{t('about.values.title')}</h2>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">🌟</div>
                <h3>{t('about.values.quality.title')}</h3>
                <p>{t('about.values.quality.text')}</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🌍</div>
                <h3>{t('about.values.accessibility.title')}</h3>
                <p>{t('about.values.accessibility.text')}</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🔒</div>
                <h3>{t('about.values.privacy.title')}</h3>
                <p>{t('about.values.privacy.text')}</p>
              </div>
              <div className="value-card">
                <div className="value-icon">💫</div>
                <h3>{t('about.values.fresh.title')}</h3>
                <p>{t('about.values.fresh.text')}</p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>{t('about.contact.title')}</h2>
            <p>{t('about.contact.text')}</p>
            <p>
              <a href="/contact" className="contact-link">{t('about.contact.link')}</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default About;
